import React, { useEffect, useState, useRef } from "react";

import ReportFilter from "./ReportFilter";

import _ from "lodash";
import SearchBar from "material-ui-search-bar";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  searchContainer: {
    width: "100%",
    margin: "auto 5px !important"
  },
}))

const ReportsInDetail = (props) => {

  const classes = useStyles()
  const {reconciliationReport, setSelectedReconciliation} = props;
  const originalDataRows = reconciliationReport?.information || [];

  const [searchedValue, setSearchedValue] = useState("")
  const [filteredValue, setFilteredValue] = useState(null)
  const [searchStarted, setSearchStarted] = useState(false);
  const [dataRows,setDataRows] = useState([...originalDataRows])
  const debounceValue = useRef(
    _.debounce((searchText) => {
      handleSearch(searchText)
    }, 300)
  );

  const handleChange = (val) => {
    setSearchedValue(val);
    debounceValue.current(val);
  };

  const handleSearch = (searchText) => {
    setFilteredValue(null)
    setSearchStarted(true)
    const filteredResults = originalDataRows.filter( (row) => {
      return row.sheet_number.toLowerCase().includes(searchText.toLowerCase()) 
      || row.sheet_name.toLowerCase().includes(searchText.toLowerCase());
    });
    setDataRows(filteredResults);
  }

  const cancelSearch = () => {
    setSearchedValue("")
    setDataRows([...originalDataRows])
  }

  const handleFilter = () => {
    const filteredResults = originalDataRows.filter( (row) => {
      return filteredValue.map( (fv) => row[fv]).includes(true)
    })
    setDataRows(filteredResults);
  }

  useEffect(() => {
    if(filteredValue) {
      setSearchedValue("")
      handleFilter()
    }
  },[filteredValue])

  return (
    <>
      <div className="reconciliation-sidebar-section-summary-details">

        <div className="flex-box section-summary-details-group">

          <div className="section-summary-details-search-group">

            <SearchBar
              autoFocus
              value={searchedValue}
              placeholder="Search Sheet No/Name"
              onCancelSearch={() => cancelSearch()}
              //onRequestSearch={() => handleSearch()}
              className="section-summary-details-search-bar"
              onChange={(newValue) => handleChange(newValue)}
              classes={{ searchContainer: classes.searchContainer }}
            />
          </div>

          <ReportFilter
            filteredValue={filteredValue}
            searchStarted={searchStarted}
            setSearchStarted={setSearchStarted}
            setFilteredValue={setFilteredValue}
          />

        </div>

        <div className="section-summary-details-table">

          <div className="section-summary-details-tableheader">
            <div>Sheet No</div>
            <div className="section-summary-details-tableheader-name">
              Sheet Name
            </div>
          </div>

          <div className="section-summary-details-tablebody">
            {dataRows.length > 0
              ? dataRows.map((item,index) => {
                  return (
                    <div
                      key={index}
                      onClick={() => {
                        item?.page_no && item?.quads && setSelectedReconciliation(item)
                      } }
                      className={`section-summary-details-tablebody-row
                      ${item.not_in_plan ? "" : "pointer-yes" }`}
                    >
                      <div className="section-summary-details-tablebody-start">
                        {item.sheet_number || "-"}
                      </div>
                      <div title={item.sheet_name} className="section-summary-details-tablebody-middle">
                        {item.sheet_name}
                      </div>
                      <div
                        className={`section-summary-details-tablebody-end 
                        ${item.matched ? "summary-overview-matched" : 
                        item.not_in_plan ? "summary-overview-notinplan" : "summary-overview-additional"}`}
                      >
                        {item.matched ? "Matched" : item.not_in_plan ? "Not in Plan" : "Additional"}
                      </div>
                    </div>
                  );
                })
              : 
                <div className="no-result">
                  <div className="no-result-text">
                    {searchedValue ? 
                      `No search results for "${searchedValue}"` :
                      "No results found"
                    }
                  </div>
                </div>
              }
          </div>

        </div>
      </div>
    </>
  );
}

export default ReportsInDetail;